import { css } from '@emotion/react'
import { HFlow, Text, VFlow } from 'bold-ui'
import { MetaPath } from 'util/metaPath'

import { PassouFalhouEnum } from '../enums-consultaSeguimento'
import { ConsultaSeguimentoOutroFieldModel } from '../model-consultaSeguimento'
import {
  ExemplosHorizontalColumnField,
  ExemplosHorizontalColumnFieldComponents,
  ExemplosHorizontalColumnFieldModel,
} from './ExemplosHorizontalColumnField'
import { ExemplosHorizontalFieldIndicatorFalhou } from './ExemplosHorizontalFieldIndicatorFalhou'
import { ExemplosHorizontalFieldIndicatorPassou } from './ExemplosHorizontalFieldIndicatorPassou'

export type ExemplosHorizontalFieldModel<T extends string> = Record<
  PassouFalhouEnum,
  ExemplosHorizontalColumnFieldModel<T>
>

export type ExemplosHorizontalFieldOptions<T extends string> = Record<
  PassouFalhouEnum,
  Array<{ value: T; label: string }>
>

interface ExemplosHorizontalFieldProps<T extends string> {
  name: MetaPath<ExemplosHorizontalFieldModel<T>>
  nameOutro: MetaPath<ConsultaSeguimentoOutroFieldModel>
  label: string
  options: ExemplosHorizontalFieldOptions<T>
  components?: Partial<Record<PassouFalhouEnum, ExemplosHorizontalColumnFieldComponents>>
  showIndicator?: PassouFalhouEnum | null
  showTagOptional?: Partial<Record<PassouFalhouEnum, boolean>>
  onChange?: () => void
}

export function ExemplosHorizontalField<T extends string>(props: Readonly<ExemplosHorizontalFieldProps<T>>) {
  const { name, nameOutro, label, options, components, showIndicator, showTagOptional, onChange } = props

  return (
    <VFlow vSpacing={0.5}>
      <Text fontWeight='bold'>{label}</Text>
      <VFlow vSpacing={0}>
        <HFlow hSpacing={0.5} style={styles.hFlow}>
          <ExemplosHorizontalColumnField
            name={name.PASSOU}
            nameOutro={nameOutro}
            label='Exemplos Passou'
            options={options.PASSOU}
            required
            components={components?.PASSOU}
            showIndicator={showIndicator === PassouFalhouEnum.PASSOU}
            showTagOptional={showTagOptional?.PASSOU}
            onChange={onChange}
          />
          <ExemplosHorizontalColumnField
            name={name.FALHOU}
            nameOutro={nameOutro}
            label='Exemplos Falhou'
            options={options.FALHOU}
            required
            components={components?.FALHOU}
            showIndicator={showIndicator === PassouFalhouEnum.FALHOU}
            showTagOptional={showTagOptional?.FALHOU}
            showOutroField
            onChange={onChange}
          />
        </HFlow>
        {showIndicator === PassouFalhouEnum.PASSOU && <ExemplosHorizontalFieldIndicatorPassou />}
        {showIndicator === PassouFalhouEnum.FALHOU && (
          <ExemplosHorizontalFieldIndicatorFalhou style={styles.indicatorFalhou} />
        )}
      </VFlow>
    </VFlow>
  )
}

const styles = {
  hFlow: css`
    grid-template-columns: 1fr 1fr;
  `,
  indicatorFalhou: css`
    margin-left: calc(50% - 1px);
  `,
}
